let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("2MoaQ")).then(() => parcelRequire('6G1GD'));